const advantages = [
    {
        id: 1,
        title: "1. Hệ thống nguồn",
        description: "Điều khiển động cơ servo, có thể xuất khoảng cách lực ở tốc độ thấp, độ chính xác định vị cao, lên đến cấp độ micron",
        image: "/files/images/advantageimg_1.jpg"
    },
    {
        id: 2,
        title: "2. Thiết bị đệm vải",
        description: "Rãnh V sâu, bộ đệm vải lớn, giải phóng hoàn toàn lực căng, độ đàn hồi vừa phải.",
        image: "/files/images/advantageimg_2.jpg"
    },
    {
        id: 3,
        title: "3. Thiết bị xả vải",
        description: "Máy tính vi điều khiển tự động tính toán rằng cảm biến quang điện tự động cấp vải.",
        image: "/files/images/advantageimg_3.jpg"
    },
    {
        id: 4,
        title: "4. Thiết bị san phẳng công suất",
        description: "Sản phẩm được cấp bằng sáng chế san phẳng vải và cho phép kéo ra khỏi mép vải cuộn, có lợi cho mặt đối diện, hiệu quả đối với vải dệt kim rõ ràng, được sử dụng rộng rãi trong vải dệt kim.",
        image: "/files/images/advantageimg_4.jpg"
    },
    {
        id: 5,
        title: "5. Thiết bị sang hai bên",
        description: "Cảm biến quang điều khiển tự động đường biên PLC, mạch đơn giản, độ nhạy có thể điều chỉnh được.",
        image: "/files/images/advantageimg_5.jpg"
    },
    {
        id: 6,
        title: "6. Thiết bị cấp vải",
        description: "Điều khiển động cơ servo, hệ thống theo dõi thời gian thực, đồng bộ hóa điện tử, lực căng cấp vải đồng đều.",
        image: "/files/images/advantageimg_6.jpg"
    },
    {
        id: 7,
        title: "7. Thiết bị theo dõi tự động đàn hồi",
        description: "Cảm biến quang giám sát độ đàn hồi của vải theo thời gian thực, có thể tự động điều chỉnh độ lỏng khi siết chặt và tự động điều chỉnh lực căng khi lỏng.",
        image: "/files/images/advantageimg_7.jpg"
    },
    {
        id: 8,
        title: "8. Bộ nhớ vải",
        description: "Dữ liệu của 30 loại vải có thể lưu dữ liệu của vải đã trải. Người dùng có thể gọi lại tên vải đã lưu trước đó mà không cần đặt lại, tiện lợi và thực dụng.",
        image: "/files/images/advantageimg_8.jpg"
    },
    {
        id: 9,
        title: "9. Hiệu quả trải vải",
        description: "Phẳng, căn chỉnh tốt, đàn hồi, độ căng tốt và phù hợp với nhiều loại vải đa dạng.",
        image: "/files/images/advantageimg_9.jpg"
    },
];

export default advantages;
